module.exports = __webpack_public_path__ + "feacf306067555e79fe3240a5c46183c.svg";